import InsufficientFundsBar from './InsufficientFundsBar';

export default InsufficientFundsBar;
